import { GET_ONLINE_OFFLINE_DRIVERS_COUNT, GET_POSITIONS_DATE_WISE, GET_SCHOOL_MARKER_DETAILS, GET_STUDENT_COUNTS, RESET_POSiTION_DATA } from "../actions/TraccarActions";

const initialState = {// initialize states
  traccarDetails: [],
  school_marker_details: [],
  driver_counts: [],
  positions_data: []
  // status: true,
};

const TraccarReducer = function (state = initialState, action) {
  const defaultData = [{
    isDataCame: "Data not Found"
  }]

  switch (action.type) {
    case GET_STUDENT_COUNTS: { // save student counts into state    
      return { ...state, traccarDetails: (action.payload.data) ? action.payload.data : [] };
    }
    case GET_SCHOOL_MARKER_DETAILS: { // save student counts into state    
      return { ...state, school_marker_details: (action.payload.data) ? action.payload.data : [] };
    }
    case GET_ONLINE_OFFLINE_DRIVERS_COUNT: { // save student counts into state    
      return { ...state, driver_counts: (action.payload.data) ? action.payload.data : [] };
    }
    case GET_POSITIONS_DATE_WISE: { // save student counts into state    
      return { ...state, positions_data: (action.payload.data) ? action.payload.data : defaultData };
    }
    case RESET_POSiTION_DATA: { // save student counts into state    
      return { ...state, positions_data: defaultData };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default TraccarReducer;

